export function isKeydownEscapeKey(ev) {
  // Esc is the non-standard IE < Edge name of key
  return ev.key === 'Escape' || ev.key === 'Esc';
}
